import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { connect, ConnectedProps } from 'react-redux'
import ModalCEWarehouseWorkingCenter from './ModalCEWarehouseWorkingCenter'
import ModalDeleteWarehouseWorkingCenter from './ModalDeleteWarehouseWorkingCenter'
import { WarehouseModelTypeExtended } from './types'
import { ComponentWithPermissions } from '../../../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderStateName, CustomRenderCountryName, CustomRenderBoolean, DeleteRow } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { WarehousePayload } from '../../../../../../../../../utils/reducers/company/warehouses'
import { getDictionaryCountries } from '../../../../../../../../../utils/reducers/getters'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import ModalSmallFilled from '../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { useCallback } from 'react'
import { twinFetchPostText } from '../../../../../../../../../utils/globals/data'

interface WarehousesWorkingCenterProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
}

const WarehousesWorkingCenter: React.FC<WarehousesWorkingCenterProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('warehouses', 'Almacenes'),
        newText: t('addWarehouse', 'Añadir almacén'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableConnect} extraWhereParams={{ 'WorkingCenterId': basicData?.id }} pageData={pageData} CreateModalComponent={ModalCEWarehouseWorkingCenter} DeleteModalComponent={ModalDeleteWarehouseWorkingCenter} EditModalComponent={ModalCustomRenderBoolean} userPermissions={userPermissions}  />
    )
}
interface TableWarehousesWorkingCenterProps extends TableComponentBaseScreenInnerProps { }

const TableWarehousesWorkingCenter: React.FC<TableWarehousesWorkingCenterProps> = ({ setTableInstance, userPermissions, extraWhereParams, setOpened }) => {
    const { t } = useTwinTranslation()
    const countries = getDictionaryCountries()
    const columns: ColumnTableSchema<WarehouseModelTypeExtended> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            minWidth: 120,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Código'),
            sortable: true,
            width: 100
        },
        {
            id: 'address',
            dataKey: 'address',
            label: t('address', 'Dirección'),
            sortable: true,
            minWidth: 130,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('address', 'Dirección'), }
            }
        },
        {
            id: 'city',
            dataKey: 'city',
            label: t('city', 'Ciudad'),
            minWidth: 120,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('city', 'Ciudad'), }
            }
        },
        {
            id: 'state',
            dataKey: 'state',
            label: t('state', 'Provincia'),
            customRender: (parameterValue, allRowData) => <CustomRenderStateName stateId={parameterValue} allRowData={allRowData} />,
        },
        {
            id: 'country',
            dataKey: 'country',
            label: t('country', 'País'),
            customRender: (parameterValue) => <CustomRenderCountryName countryId={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: countries, label: t('country', 'País') }
            },
            generalSearchable: false
        },
        {
            id: 'is_main',
            dataKey: 'WarehouseWorkingCenters.is_main',
            label: t('byDefault', 'Por defecto'),
            customRender: (parameterValue, allRowData) => <CustomRenderBoolean className='cursor-pointer' onClick={() => setOpened({
                type: 'edit',
                allRowData
            })} value={String(parameterValue) === 'true'} width={50} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='warehousesOfWorkingCenter' columns={columns} getDataFrom='/api/app/workingCenter/workingCenterWarehouse/getAllWarehousesOfWorkingCenter'
        setTableInstance={setTableInstance} extraWhereParams={extraWhereParams}  />
    )
}


const warehousesDispatch = {
    setWarehouses: (payload: WarehousePayload) => ({ type: 'CHANGE_WAREHOUSE', payload }),
}

export type ReduxWarehouses = ConnectedProps<typeof warehousesConnect>
const mapWarehousesConnector = (state: AllReduxPayloads) => ({ warehouses: state.warehouses })
const warehousesConnect = connect(mapWarehousesConnector, warehousesDispatch)

const warehousesConnectLoading = withLoading(TableWarehousesWorkingCenter, [{ fetchUrl: '/api/app/warehouse/getAllWarehouses', propName: 'warehouses', setFunctionName: 'setWarehouses' }])

const TableConnect = warehousesConnect(warehousesConnectLoading)

interface ModalCustomRenderBooleanProps extends ModalCustomRenderBooleanLogicProps {
}

const ModalCustomRenderBoolean: React.FC<ModalCustomRenderBooleanProps> = ({ setOpened, ...logic }) => {
    const { t } = useTwinTranslation()
    const { updateShippingServiceMain } = useModalCustomRenderBooleanLogic({ setOpened, ...logic })
    return (
        <ModalSmallFilled translations={{
            title: t('sureUpdateCustomRenderBoolean', '¿Seguro que quieres modificarlo?'),
            subtitle: t('changeDefaultState', 'Cambiará el estado en por defecto'),
            buttonAccept: t('accept', 'Acceptar')
        }} onAccept={updateShippingServiceMain} opened={true} setOpened={() => setOpened(null)} />
    )
}


interface ModalCustomRenderBooleanLogicProps extends ModalEditComponentProps {
}

const useModalCustomRenderBooleanLogic = ({ allRowData, onSubmit }: ModalCustomRenderBooleanLogicProps) => {
    const updateShippingServiceMain = useCallback(async () => {
        const result = await twinFetchPostText('/api/app/workingCenter/workingCenterWarehouse/assignWorkingCenterToWarehouse', {
            WarehouseId: allRowData?.id,
            WorkingCenterId: allRowData?.["WarehouseWorkingCenters.WorkingCenterId"],
            is_main: !allRowData?.is_main
        })
        if (result) {
            onSubmit?.(result, {})
        }
    }, [allRowData, onSubmit])
    return { updateShippingServiceMain }
}


export default WarehousesWorkingCenter